import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import DigitizeImg from "../../images/location_new/fold5/img01.webp";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { Link } from "gatsby";

function Digitize(props) {
  return (
    <div className="digitize_sec p-100" style={{ backgroundColor: "#1d8633" }}>
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="my-auto">
            <h2>
              Future-Proofing Your Florida Business with Software Digitization
            </h2>
            <p>
              In a world driven by technology, the future belongs to those who
              adapt and innovate. For Florida businesses, software digitization
              is not just an option; it's the key to staying competitive and
              resilient in an ever-evolving marketplace.
            </p>
            <p>
              By embracing software digitization, you're not only streamlining
              your operations but also ensuring that your business remains agile
              and responsive to changing customer needs.
            </p>
            <p>
              With tailored software solutions, you can efficiently manage
              processes, enhance customer experiences, and gain valuable
              insights into your operations.
            </p>
            <Link
              style={{
                backgroundColor: "#fff",
                color: "#1d8633",
                border: "1px solid #1d8633",
              }}
              to="/contact"
              className="border_btn dark_btn"
              aria-label="TekRevol Contact"
              rel="noopener"
            >
              Book A Consultation Now!
            </Link>
          </Col>
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="digitize_img">
            <LazyLoadImage
              src={DigitizeImg}
              effect="blur"
              alt="Image"
              className="img-fluid"
            />
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Digitize;
